import React from 'react';


export const OfertaError = React.memo((data) => {
    return (
        <div className="promo expirada">
                        
            <div className="titulo">Ups!, algo no salió bien.</div>
            <p>Espera unos minutos y recarga esta página</p>

            
        
        </div>
    )
})
